import React from "react";
import { cn } from "../utils/cn";
import  Button  from "../components/UI/Button";

interface MeetingDateSearchProps {
  onDateSelect: (date: string) => void;
  value?: string;
}

const MeetingDateSearch: React.FC<MeetingDateSearchProps> = ({ onDateSelect, value }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = e.target.value;
    if (selectedDate.length === 10) {
      onDateSelect(selectedDate);
    } else {
      onDateSelect("");
    }
  };

  const handleReset = () => {
    onDateSelect("");
  };

  return (
    <div className="flex justify-start mb-6">
      <div className="flex items-center gap-3 ml-auto">
        <span className="text-sm font-medium text-text-main">חיפוש לפי תאריך:</span>
        <input
          type="date"
          value={value}
          onChange={handleChange}
          className={cn(
            "rounded-xl px-4 py-2 text-base font-sans",
            "bg-white text-text-main border border-border shadow-sm",
            "focus:outline-none focus:ring-2 focus:ring-primary"
          )}
        />
        {value && (
          <Button
            type="button"
            onClick={handleReset}
            variant="ghost"
            size="sm"
            className="text-sm underline text-gray-600 hover:text-gray-800 px-2 py-0"
          >
            איפוס
          </Button>
        )}
      </div>
    </div>
  );
};

export default MeetingDateSearch;
